import { Reveal } from "./Reveal";

const METRICS = [
  { num: "<60 days", cap: "Idea to production for your first agentic application" },
  { num: "70%", cap: "Routine business execution shifted to AI agents" },
  { num: ">95%", cap: "Assured agentic workflow precision" },
  { num: "30%", cap: "Operating costs slashed with an agentic workforce" },
  { num: "3\u20135\u00D7", cap: "Faster rollout of subsequent agentic AI use cases" },
];

const PILLARS = [
  { k: "Speed", v: "AI value in days, not years" },
  { k: "Scale", v: "Agentic workflows across functions, not silos" },
  { k: "Sustenance", v: "Self-healing operations with predictable AI economics" },
];

export const Commitments = () => (
  <section className="bg-white text-[#3E2818] pt-14 lg:pt-16 pb-14 lg:pb-16" data-testid="commitments-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 text-center">
      <div className="pt-1">
      <Reveal delay={0.02}>
        <h2 className="font-display font-medium tracking-tight text-xl sm:text-2xl lg:text-[2rem] leading-[1.15] max-w-3xl mx-auto">
          <span className="text-[#3E2818]/40">STOP</span> spending on AI experiments. <span className="text-[#E0902B]">START</span> achieving AI outcomes.
        </h2>
      </Reveal>

      <Reveal delay={0.08}>
        <div className="mt-10 flex flex-wrap justify-center gap-y-7">
          {METRICS.map((m, i) => (
            <div key={m.cap} className={`px-6 sm:px-8 ${i !== 0 ? "border-l border-[#3E2818]/10" : ""}`}>
              <div className="font-display font-medium text-2xl lg:text-[2rem] leading-none text-[#E0902B]">{m.num}</div>
              <p className="mt-2.5 text-xs text-[#3E2818]/80 leading-snug max-w-[9.5rem] mx-auto">{m.cap}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.14}>
        <p className="mt-10 text-xs text-[#3E2818]/90 leading-relaxed">
          {PILLARS.map((p, i) => (
            <span key={p.k} className="sm:whitespace-nowrap inline-block">
              {i !== 0 && <span className="mx-3 text-[#3E2818]/25">/</span>}
              <span className="font-mono2 font-bold uppercase tracking-[0.18em] text-[#E0902B]">{p.k}</span>
              <span className="ml-2">{p.v}</span>
            </span>
          ))}
        </p>
      </Reveal>
      </div>
    </div>
  </section>
);
